import { Stack, Typography } from '@mui/material'
import OrphanSteps from './OrphanSteps'
import TaskGroup from './TaskGroup'

export default function TimelineBody({
  groups,
  orphans,
  trimmed,
  streaming,
  citations = [],
}) {
  return (
    <Stack sx={{ gap: 0, mt: 0.75 }}>
      {trimmed ? (
        <Typography sx={{ fontSize: 'var(--app-thought-font-size)', color: 'var(--app-text-tertiary)' }}>
          Earlier steps not retained
        </Typography>
      ) : null}
      {groups.map((group) => (
        <TaskGroup
          key={group.task.id}
          task={group.task}
          rows={group.rows}
          streaming={streaming}
        />
      ))}
      <OrphanSteps
        rows={orphans}
        hasGroups={Boolean(groups.length)}
        streaming={streaming}
        citations={citations}
      />
    </Stack>
  )
}
